const getProgressColor = (percent: number): string => {
  if (percent >= 100) return "#4CAF50"
  if (percent >= 50) return "#2A7D8C"
  return "#FF9800"
}

export { getProgressColor }
